import request from '@/utils/request'


// 查询打卡心情列表
export function listPack(query) {
  return request({
    url: '/emotion/pack/list',
    method: 'get',
    params: query
  })
}

// 查询打卡心情分页
export function pagePack(query) {
  return request({
    url: '/emotion/pack/page',
    method: 'get',
    params: query
  })
}

// 查询打卡心情详细
export function getPack(data) {
  return request({
    url: '/emotion/pack/detail',
    method: 'get',
    params: data
  })
}

// 新增打卡心情
export function addPack(data) {
  return request({
    url: '/emotion/pack/add',
    method: 'post',
    data: data
  })
}

// 修改打卡心情
export function updatePack(data) {
  return request({
    url: '/emotion/pack/edit',
    method: 'post',
    data: data
  })
}

// 删除打卡心情
export function delPack(data) {
  return request({
    url: '/emotion/pack/delete',
    method: 'post',
    data: data
  })
}
